import axios from 'axios'
import { ENDPOINTS } from 'src/constants/endpoints'

import { POLICY_API_VERSION } from 'src/app/auth/domain/models/terms-acceptance'
import { http } from 'src/interfaces/http'

interface IPolicyAcceptanceDTO {
  accepted: boolean
  accepted_at: string | null
  policy_version: string
}

export interface ICheckPolicyAcceptanceResult {
  accepted: boolean
}

export const checkPolicyAcceptance =
  async (): Promise<ICheckPolicyAcceptanceResult> => {
    try {
      const { data } = await http.get<IPolicyAcceptanceDTO>(
        ENDPOINTS.hanwha.policyAcceptanceCheck(POLICY_API_VERSION),
      )
      return { accepted: data.accepted }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return { accepted: false }
      }
      throw error
    }
  }
